import env from '../env';
import getDomain from './get-domain';
export const getHostname = url => {
  const {
    hostname
  } = new URL(url, global.location.href);
  return hostname;
};
export const isAllowedHostname = (url, {
  allowedHostnames,
  allowSubdomains = true
} = {}) => {
  const parsed = decodeURIComponent(url);
  // will match any URL that starts with an external scheme (eg. `mailto:`, `https:`, `ftp:`, `git+ssh:`, `//`)
  if (/^(?:[a-z][a-z0-9+.-]*:|\/\/)/i.test(parsed)) {
    const defaultHostnames = (env.REACT_APP_ALLOWED_EXTERNAL_HOSTNAME || '').replace(/\s/g, '').split(',');
    const hostnames = (allowedHostnames || defaultHostnames).concat(global.location.hostname).filter(Boolean);
    const targetHostname = getHostname(parsed);
    const haystack = allowSubdomains ? hostnames.map(getDomain) : hostnames;
    const needle = allowSubdomains ? getDomain(targetHostname) : targetHostname;
    return haystack.includes(needle);
  }

  // relative URLs
  return true;
};
export const joinPaths = (...paths) => paths.reduce((accumulator, currentValue) => {
  const val = currentValue != null ? String(currentValue).trim() : currentValue;
  if (!val) return accumulator;
  const ends = accumulator.endsWith('/');
  const starts = val.startsWith('/');
  const junction = starts || ends || accumulator === '' ? '' : '/';
  const nextPath = starts && ends ? val.slice(1) : val;
  return `${accumulator}${junction}${nextPath}`;
}, '');